import { type } from "arktype";

export const NumericStringArraySchema = type("string.numeric.parse").array();
export const DateStringArraySchema = type("/^(\\d{4})-(\\d{2})-(\\d{2})$/").array();

export const ConfigSchema = type({
	enabledDays: NumericStringArraySchema,
	disabledDates: DateStringArraySchema,
	forceEnabledDates: DateStringArraySchema,
	"todayOpen?": "boolean",
	"tomorrowOpen?": "boolean",
	daysInAdvance: "string.numeric.parse",
	labelTemplateSelector: "string",
});

export type Config = typeof ConfigSchema.infer;
